import BaseService from "@/boot/BaseService";

class ProfileService extends BaseService {
    constructor() {
        super(null, "/perfil");
    }

    async updatePassword(data) {
        return await this.put("/password", data);
    }
}

export default new ProfileService();
